// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3EhKT","col":"styles_col__cbLw2"};